import { Table } from 'reactstrap';
import moment from 'moment';
import './TravelRequestOptions.scss';
import { FLIGHT_COLUMNS } from './constants';

function FlightInformation({ isLoading, flightDetails, showTitle = true }) {
  return (
    <div className="d-flex flex-column gap-2">
      {showTitle && <div className="fw-semibold">Flight Information</div>}
      <div className="table-responsive">
        <Table
          hover
          className="tra-table align-middle text-nowrap table-radius"
          id="flight-information-table"
        >
          <thead>
            <tr>
              {FLIGHT_COLUMNS.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {flightDetails?.map((flight, index) => (
              <tr key={index}>
                <td>{flight.TravelFrom_Description || 'N/A'}</td>
                <td>{flight.TravelToCountry_Description || 'N/A'}</td>
                <td>{flight.TravelTo_Description || 'N/A'}</td>
                <td>
                  {flight.TravelDate
                    ? moment(flight.TravelDate).format('L')
                    : 'N/A'}
                </td>
                <td>
                  {flight.TravelTime
                    ? moment(flight?.TravelTime, 'HH:mm:ss').format('hh:mm A')
                    : '-' || 'N/A'}
                </td>
                <td>{flight.Airline_Description || 'N/A'}</td>
                <td>{flight.TravelClass || 'N/A'}</td>
              </tr>
            ))}
            {!isLoading && !flightDetails?.length && (
              <tr>
                <td colSpan={FLIGHT_COLUMNS.length} className="text-center">
                  No flight details available
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default FlightInformation;
